import clsx from 'clsx'
import { type ChangeEvent, type ForwardedRef, forwardRef } from 'react'

import { FvButton, Icon, SelectField } from '@fv/client-components'
import { timeOptions } from '@fv/client-core'
import { militaryTimeFormat } from '@fv/client-types'
import { fvDate } from '@fv/dates'

type TimeSelectFieldProps = {
  containerClassName?: string
  format?: string
  name: string
  setValue: (t: string | null) => void
  value?: string
}

export const TimeSelectField = forwardRef(
  (
    {
      containerClassName,
      format = militaryTimeFormat,
      name,
      setValue,
      value,
    }: TimeSelectFieldProps,
    ref: ForwardedRef<HTMLSelectElement>,
  ) => {
    const time = value ? fvDate(value, format) : null
    const parsedTime = time ? time.format('h:mm') : null
    const timeOfDay = time ? time.format('A') : 'AM'

    const changeTime = (e: ChangeEvent<HTMLSelectElement>) => {
      const selectedValue = e.target.value

      if (selectedValue === '-') setValue(null)
      else {
        const time = fvDate(`${selectedValue} ${timeOfDay}`, 'h:mm A')
        setValue(time.format(format))
      }
    }

    const changeTimeOfDay = () => {
      if (!parsedTime) return
      const nextTimeOfDay = timeOfDay === 'AM' ? 'PM' : 'AM'
      const time = fvDate(`${parsedTime} ${nextTimeOfDay}`, 'h:mm A')

      setValue(time.format(format))
    }

    return (
      <span
        className={clsx('input-group input-group--flex', containerClassName)}
      >
        <SelectField
          className="form-control form-control--select"
          ref={ref}
          name={name}
          onChange={changeTime}
          options={['-', ...timeOptions]}
          required
          value={parsedTime ?? '-'}
        />
        <FvButton
          theme="default"
          className="input-group--flex__btn"
          id={`${name}TimeOfDay`}
          onClick={changeTimeOfDay}
        >
          <Icon icon="arrows-alt-v" />
          <span>{timeOfDay}</span>
        </FvButton>
      </span>
    )
  },
)
